export const persistFormDataInSession = (key: string, data: unknown) => {
  try {
    const serializedData = JSON.stringify(data);

    window.sessionStorage.setItem(`formData:${key}`, serializedData);
  } catch {
    return;
  }
};

export const retrieveFormDataFromSession = (key: string): unknown => {
  try {
    const serializedData = window.sessionStorage.getItem(`formData:${key}`);

    return serializedData !== null ? JSON.parse(serializedData) : null;
  } catch {
    return null;
  }
};

export const removeFormDataFromSession = (key: string) => {
  window.sessionStorage.removeItem(`formData:${key}`);
};
